module.exports = __webpack_public_path__ + "caracol-preview.jpg?0e584559dac7813b7e171c5a93183064";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caracol-preview.jpg
// module id = 170
// module chunks = 0